// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__XH-i9","right":"Footer_right__21Aik","buttons":"Footer_buttons__168NL"};